export enum PolicyStatus {
  Policy = 1,
  NoPolicy = 2
}
